<template>
  <p class="tw-font-base tw-text-neutral-900 tw-leading-snug">
    <slot />
  </p>
</template>
